import TeaserOptionsImpl from './teaser-options.js';
import MojitoCore from 'mojito/core';
import MojitoServices from 'mojito/services';
import PropTypes from 'prop-types';

const UIView = MojitoCore.Presentation.UIView;
const { TEASER_TYPE } = MojitoServices.Betslip.types;
/**
 * Teaser options.
 *
 * @class TeaserOptions
 * @memberof Mojito.Modules.BetslipView
 */

/**
 * TeaserOptions prop types.
 *
 * @property {Map<Mojito.Services.Betslip.types.TEASER_TYPE, Array<Mojito.Services.Betslip.types.TeaserOption>>} options - Map of teaser options to teaser types.
 * @property {Mojito.Services.Betslip.types.TEASER_TYPE} [selectedTeaserType] - Selected teaser type.
 * @property {string} [class] - Class name assigned to the root element.
 *
 * @memberof Mojito.Modules.BetslipView.TeaserOptions
 */
const propTypes = {
    options: PropTypes.object.isRequired,
    selectedTeaserType: PropTypes.oneOf(Object.values(TEASER_TYPE)),
    class: PropTypes.string,
};

export default UIView('TeaserOptions', TeaserOptionsImpl, propTypes);
